import React, { useState, useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Products } from "../components/Products";
import { Services } from "../components/Services";
import { Stats } from "../components/Stats";
import { References } from "../components/References";
import { FAQ } from "../components/FAQ";
import { About } from "../components/About";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { WhatsAppFloat } from "../components/WhatsAppFloat";
import { useReveal } from "../hooks/useReveal";
import { useI18n } from "../context/I18nContext";
import {
  getSettings, getProducts, getServices, getFaqs, getReferences, getAbout,
} from "../lib/store";

export default function HomePage() {
  const { lang } = useI18n();

  // Read from localStorage store (admin panel writes here)
  const [settings,   setSettings]   = useState(getSettings);
  const [products,   setProducts]   = useState(() => getProducts().filter(p => p.active && p.lang === lang));
  const [services,   setServices]   = useState(() => getServices().filter(s => s.active && s.lang === lang));
  const [faqs,       setFaqs]       = useState(() => getFaqs().filter(f => f.active && f.lang === lang));
  const [references, setReferences] = useState(() => getReferences().filter(r => r.active));
  const [about,      setAbout]      = useState(getAbout);

  // Re-read when lang changes
  useEffect(() => {
    setSettings(getSettings());
    setProducts(getProducts().filter(p => p.active && p.lang === lang));
    setServices(getServices().filter(s => s.active && s.lang === lang));
    setFaqs(getFaqs().filter(f => f.active && f.lang === lang));
    setReferences(getReferences().filter(r => r.active));
    setAbout(getAbout());
  }, [lang]);

  useReveal();

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero settings={settings} />
        <Stats settings={settings} />
        <Products items={products} />
        <Services items={services} />
        <References items={references} />
        <FAQ items={faqs} />
        <About data={about} settings={settings} />
        <Contact settings={settings} />
      </main>
      <Footer settings={settings} />
      <WhatsAppFloat settings={settings} />
    </div>
  );
}
